import Redirects from "@faire/retailer-visitor-shared/services/Redirects";
import { redirectRules } from "@faire/retailer-visitor-shared/initializers/redirectRules";
export var watchForRedirects = function(history) {
    new Redirects(redirectRules).listen(history);
};
